<template>
  <li :class="classes">
    <a
      :href="url"
      class="chip__link"
      data-test-id="chip-link"
      rel="noopener"
    >
      <img
        v-lazy="thumbnailUrl"
        :data-test-src="thumbnailUrl"
        role="presentation"
        class="chip__image"
        data-test-id="chip-image"
        :style="{
          '--chip-thumbnail-size': `${thumbnailSize}px`,
        }"
      >
      <span
        v-safe-html="text"
        class="chip__text"
      />
    </a>
  </li>
</template>

<script>
import classes from '~~/common/vue/mixins/classes';

export const THUMBNAIL_SIZE = 32;

export default {
  name: 'EChip',
  mixins: [classes],
  props: {
    url: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    thumbnailUrl: {
      type: String,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
      cssClass: true,
    },
  },
  computed: {
    thumbnailSize() {
      return THUMBNAIL_SIZE;
    },
  },
  methods: {
    onClick(event) {
      if (this.$listeners.select) {
        event.preventDefault();
        this.$emit('select');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.chip {
  @include elevation(1);

  background: $color-background-primary;
  border-radius: $border-radius-full;

  @include desktop {
    @include elevation(0);

    border: solid $border-width $color-border;

    &:hover {
      border-color: $color-border-hover-secondary;
    }

    &:focus-within {
      border-color: $color-border-focus-secondary;
    }
  }
}

.chip--selected {
  border-color: $aqua-30;
  background: $aqua-20;

  &:hover,
  &:focus-within {
    border-color: $aqua-40;
  }
}

.chip__link {
  align-items: center;
  display: flex;
  padding: $space-1s $space-m $space-1s $space-1s;

  &:focus {
    @extend %keyboard-nav-focus;
  }
}

.chip__image {
  border: none;
  border-radius: $border-radius-full;
  height: var(--chip-thumbnail-size);
  margin-right: $space-s;
  object-fit: cover;
  opacity: 0;
  transition: opacity $timing-1s;
  width: var(--chip-thumbnail-size);

  &[lazy=loaded] {
    opacity: 1;
  }
}

.chip__text {
  @include line-clamp(2);

  color: $gray-40;
  font-size: $font-1s;
}
</style>

<style lang="scss">
.chip__text mark {
  background: none;
  color: $gray-60;
  display: block;
  font-size: $font-s;
  font-weight: normal;
}
</style>

<docs>
# Chip (name TBC)

This component is similar to a button, containing a small thumbnail and text.
It has a special *selected* state controlled by the `selected` prop.

// TODO: this component should be moved to `common` once it is analysed by the DS
</docs>
